import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { Button, Collapse } from 'antd';

import EstacioDetallDadesBasiques from './estacioDetallDadesBasiques';
import EstacioDetallFoto from './estacioDetallFoto';
import EstacioDetallLocalitzacio from './estacioDetallLocalitzacio';
import EstacioDetallHistoricObservadors from './estacioDetallHistoricObservadors';
import EstacioDetallMetadades from './estacioDetallMetadades';
import EstacioDetallIncidencies from './estacioDetallIncidencies';
import EstacioDetallVariables from './estacioDetallVariables';
import EstacioDetallDonarDeBaixaEstacio from './estacioDetallDonarDeBaixaEstacio';

import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';
import {
    selectorDadesBasiquesOriginalsAmbCodiDeTipusEstacio,
    selectorFotosOriginals,
    selectorLocalitzacioOriginals,
    selectorMetadadesOriginalsAmbEstructura,
    selectorHistoricObservadorsOriginalsAmbNomCognomsICodi,
    selectorIncidenciesOriginalsAmbTipus
} from '../../selectors/selector_estacio_formulari_dades';
import selectorObservadorsActiusPerEstacio from '../../selectors/selector_observadors_actius_per_estacio';

import { rutaEstacions, rutaEdicioEstacions } from '../../routes/routeConstants';

const Panel = Collapse.Panel;

class EstacioDetall extends Component {

    generarBotoDonarDeBaixaEstacio() {

        const { router, dadesBasiques } = this.props;
        const { dataAlta, dataBaixa, nom } = dadesBasiques;

        if (dataAlta && !dataBaixa) {
            return (
                <EstacioDetallDonarDeBaixaEstacio
                    dataAltaEstacioText={dataAlta}
                    nomEstacio={nom}
                    router={router}
                />
            );
        }

        return null;
    }

    generarPanelSeccio(nomSeccio, keyPanelSeccio, componentSeccio) {
        return (
            <Panel header={nomSeccio} key={keyPanelSeccio}>
                {componentSeccio}
            </Panel>
        );
    }

    render() {

        const { dadesBasiques, observadorsActius, fotos, localitzacio, historicObservadors, incidencies, metadades } = this.props;

        const seccionsDetallAlCollapse = [
            {
                nom: 'Localització',
                component: <EstacioDetallLocalitzacio localitzacio={localitzacio}/>
            },
            {
                nom: 'Variables',
                component: <EstacioDetallVariables />
            },
            {
                nom: 'Metadades',
                component: <EstacioDetallMetadades metadades={metadades}/>
            },
            {
                nom: 'Històric d\'observadors',
                component: <EstacioDetallHistoricObservadors
                    historicObservadors={historicObservadors}
                />
            },
            {
                nom: 'Incidències',
                component: <EstacioDetallIncidencies incidencies={incidencies} />
            }
        ];

        const botoDonarDeBaixaEstacio = this.generarBotoDonarDeBaixaEstacio();

        return (
            <div className='estacio-introduccio-i-detall'>
                <Link to={rutaEstacions}>
                    <Button icon='left'>
                        Tornar
                    </Button>
                </Link>
                <div className='estacio-introduccio-i-detall-contenidor requadre-arrodonit-gris'>
                    <div className='estacio-detall-informacio'>
                        <EstacioDetallDadesBasiques
                            dadesBasiques={dadesBasiques}
                            observadorsActius={observadorsActius} />
                        <EstacioDetallFoto fotos={fotos} />
                        <div className='estacio-detall-collapse scrollable'>
                            <Collapse>
                                {seccionsDetallAlCollapse.map((seccio, index) => this.generarPanelSeccio(seccio.nom, index, seccio.component))}
                            </Collapse>
                        </div>
                    </div>
                </div>
                <div className='estacio-introduccio-i-detall-botons'>
                    <Link to={rutaEdicioEstacions}>
                        <Button type='primary' size='large'>
                            Editar
                        </Button>
                    </Link>
                    {botoDonarDeBaixaEstacio}
                </div>
            </div>
        );
    }
}

EstacioDetall.propTypes = {
    dadesBasiques: PropTypes.object,
    observadorsActius: PropTypes.array,
    fotos: PropTypes.array,
    localitzacio: PropTypes.object,
    metadades: PropTypes.array,
    historicObservadors: PropTypes.array,
    incidencies: PropTypes.array,
    router: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        observadorsActius: selectorObservadorsActiusPerEstacio(state),
        dadesBasiques: selectorDadesBasiquesOriginalsAmbCodiDeTipusEstacio(state),
        fotos: selectorFotosOriginals(state),
        localitzacio: selectorLocalitzacioOriginals(state),
        metadades: selectorMetadadesOriginalsAmbEstructura(state),
        historicObservadors: selectorHistoricObservadorsOriginalsAmbNomCognomsICodi(state),
        incidencies: selectorIncidenciesOriginalsAmbTipus(state)
    };
};

export default errorBoundaryWrapper(connect(mapStateToProps, null)(EstacioDetall));



// WEBPACK FOOTER //
// ./src/components/estacio/estacioDetall.js